<template>
  <div class="reversal">
    <button
      type="button"
      class="btn btn-primary"
      data-toggle="modal"
      data-target="#providerModal"
      id="addProvider"
    >
      Add or Update Provider
    </button>
    <button
      type="button"
      class="btn btn-danger mx-4"
      data-toggle="modal"
      data-target="#switchModal"
      id="addProvider"
    >
      Service Switch
    </button>
    <div class="row">
      <div class="col-12 d-flex align-items-center">
        <div class="form-row align-items-center">
          <div class="col-auto mt-2">
            <button
              type="submit"
              class="btn btn-primary mb-2 mt-4"
              @click="refresh('filter')"
            >
              Refresh List
            </button>
          </div>
        </div>
      </div>
      <div class="spinner-grow" role="status" v-if="loading === true"></div>
      <div class="alert alert-danger" role="alert" v-if="error === true">
        {{ errorMsg }}
      </div>

      <div class="col-12">
        <card class="card-plain">
          <div class="table-full-width table-responsive">
            <table class="table">
              <thead class="tms-dark">
                <tr>
                  <th scope="col" class="text-center">S/N</th>
                  <th scope="col" class="text-center">Service</th>
                  <th scope="col" class="text-center">Provider</th>
                  <th scope="col" class="text-center">Status</th>
                  <!-- <th scope="col" class="text-center">Amount</th>
                  <th scope="col" class="text-center">Provider</th>
                  <th scope="col" class="text-center">Reference</th>
                  <th scope="col" class="text-center">Product</th>
                  <th scope="col" class="text-center">Reversal Status</th>
                  <th scope="col" class="text-center">Date</th> -->
                  <!-- <th scope="col" class="text-center">Action</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(provider, index) in providers" :key="provider._id">
                  <th class="text-center">
                    {{ index + 1 }}
                  </th>
                  <td class="text-center">
                    {{ provider.service.toUpperCase() }}
                  </td>
                  <td class="text-center">
                    {{ provider.provider.toUpperCase() }}
                  </td>
                  <td class="text-center">
                    <div
                      :class="`${
                        provider.status === 'ON' ? 'bg-success' : 'bg-danger'
                      } p-1 text-white`"
                    >
                      {{ provider.status }}
                    </div>
                  </td>
                  <!-- <td class="text-center">
                    {{ `₦${format.format(provider.amount.toFixed(2))}` }}
                  </td>
                  <td class="text-center">{{ provider.provider }}</td>
                  <td class="text-center">{{ provider.reference }}</td>
                  <td class="text-center">{{ provider.product }}</td>
                  <td class="text-center">{{ provider.status }}</td>
                  <td class="text-center">
                    {{ moment(provider.createdAt).format("Y-MM-D h:mm:ss a") }}
                  </td> -->
                  <!-- <td class="text-center">
                    <drop-down class="nav-item" title="Options" id="list">
                      <div class="p-2">
                        <router-link
                          :to="`/dashboard/provider/${provider._id}`"
                        >
                          View
                        </router-link>
                      </div>
                    </drop-down>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../store/axios";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import { StatsCard } from "@/components/index";
import Paginate from "vuejs-paginate";
export default {
  components: {
    StatsCard,
    Paginate,
  },
  data() {
    return {
      error: false,
      providers: [],
      errorMsg: "",
      loading: false,
      moment,
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {
    ...mapActions(["setNotification"]),
    async refresh() {
      try {
        this.loading = true;
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/admin/getProviders`,
        );
        const { providers } = res.data;
        this.providers = providers;
      } catch (error) {
        if (error.response && error.response.data) {
          const { message } = error.response.data;
          this.setNotification({ type: "danger", message });
        } else {
          console.log(error);
          this.setNotification({
            type: "danger",
            message: "Unable to Fetch Providers",
          });
        }
      }
      this.loading = false;
    },
    async retrieveProviders() {
      try {
        this.loading = true;
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/admin/getProviders`,
        );
        const { providers } = res.data;
        this.providers = providers;
      } catch (error) {
        console.log(error);
        if (error.response && error.response.data) {
          const { message } = error.response.data;
          this.setNotification({ type: "danger", message });
        } else {
          this.setNotification({
            type: "danger",
            message: "Unable to Fetch Providers",
          });
        }
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.retrieveProviders();
  },
};
</script>
<style scoped>
.reversal {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
tbody {
  background: #fff !important;
}
.tms-dark {
  background-color: #333f48;
  color: #fff;
}
.ref {
  font-size: 8px;
}
button {
  padding: 0.2rem 10px !important;
}
.list {
  list-style-type: none;
}
</style>
